import Vue from 'vue'
import Fragment from 'vue-fragment'
import VueFullscreen from 'vue-fullscreen'
import VueObserveVisibility from 'vue-observe-visibility'
import VueTheMask from 'vue-the-mask'
import Vue2OrgTree from 'vue2-org-tree'
import 'vue2-org-tree/dist/style.css'
import App from './App.vue'
import ForbiddenDialog from './components/ForbiddenDialog.vue'
import DateFilter from './filters/date'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'

Vue.use(Vue2OrgTree)
Vue.component('ForbiddenDialog', ForbiddenDialog)
Vue.use(Fragment.Plugin)

Vue.use(VueTheMask)
Vue.use(VueFullscreen)
Vue.use(VueObserveVisibility)

import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAP_API_KEY_SERVER,
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  installComponents: true,
})

Vue.filter('date', DateFilter)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app')
